// Vendor imports
const React = require('react')
const ReactRedux = require('react-redux')
// Lib imports
const branchIntegration = require('client/lib/business-events/branch')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const toastActions = require('client-v2/common/containers/toasts/actions')

const errorMessage = 'Sorry, we could not send the SMS. Please contact support@mix.com.'
const successMessage = 'SMS sent. Go check your phone!'

/**
 * @see https://help.branch.io/using-branch/docs/text-me-the-app
 */
function useTextMeTheAppCallback() {
  const user = ReactRedux.useSelector(state => state.user)
  const dispatch = ReactRedux.useDispatch()
  return React.useCallback(
    async (phoneNumber, onError, onSuccess, deeplinkData) => {
      // Branch may not initialize if the browser has tracking prevention enabled
      let initialized = false
      try {
        initialized = await branchIntegration.initialize(user)
      } catch (err) {
        // Ignore error; initialization failed
      }
      if (!initialized) {
        dispatch(confirmModalActions.alert(errorMessage))
        return
      }
      const linkData = {
        tags: [ 'sms-app', 'mix-web' ],
        channel: 'Website',
        feature: 'TextMeTheApp',
        data: deeplinkData
      }
      try {
        await branchIntegration.sendSMS(phoneNumber, linkData)
      } catch (err) {
        if (onError) {
          onError()
        } else {
          // Fallback: show ConfirmModal
          dispatch(confirmModalActions.alert(errorMessage))
        }
        return
      }
      if (onSuccess) {
        onSuccess()
      } else {
        // Fallback: show Toast
        dispatch(toastActions.showNotice({
          message: successMessage
        }))
      }
    },
    [ dispatch, user ]
  )
}

module.exports = {
  useTextMeTheAppCallback
}
